import { defaultShouldDehydrateQuery, dehydrate, QueryCache, QueryClient } from '@tanstack/react-query'

let browserQueryClient: QueryClient | undefined = undefined

const isServer = () => typeof window === 'undefined'

const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 기본 캐싱 시간(1분)
      },
      dehydrate: {
        // include pending queries in dehydration
        shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
        shouldRedactErrors: (_) => {
          // We should not catch Next.js server errors
          // as that's how Next.js detects dynamic pages
          // so we cannot redact them.
          // Next.js also automatically redacts errors for us
          // with better digests.
          return false
        },
      },
    },
    queryCache: new QueryCache({
      onSuccess(_, query) {
        if (query?.meta && 'onSuccessCallback' in query.meta && typeof query.meta.onSuccessCallback === 'function') {
          query.meta.onSuccessCallback()
        }
      },
    }),
  })
}

export const getQueryClient = (): QueryClient => {
  if (isServer()) {
    return createQueryClient()
  }

  if (!browserQueryClient) {
    browserQueryClient = createQueryClient()
  }

  return browserQueryClient
}

/**
 * HydrationBoundary용 dehydrate 헬퍼.
 * pending 쿼리를 제외하여 TransformStream TypeError를 방지합니다.
 * pending 쿼리는 ReactQueryStreamedHydration이 스트리밍으로 처리합니다.
 */
export const dehydrateQueryClient = (queryClient: QueryClient) => {
  return dehydrate(queryClient, {
    shouldDehydrateQuery: (query) => {
      if (!defaultShouldDehydrateQuery(query)) {
        return false
      }
      return query.state.status !== 'pending'
    },
  })
}
